// extracted by mini-css-extract-plugin
module.exports = {"page":"index-module--page--3V7R-","flowersandpie":"index-module--flowersandpie--3ueCp"};